import Modal, { ModalSwitch } from './modal/Modal'
import LogoutModal from './LogoutModal'
import HelpModal from './HelpModal'
import SummaryModal from './SummaryModal'
import ContractIdModal from './ContractIdModal'
import DefinitionIdModal from './DefinitionIdModal'
import ContentModal from './ContentModal'
import FileModal from './FileModal'
import CoachModal from './CoachModal'

export {
  Modal,
  ModalSwitch
}

export const Modals = {
  Logout: LogoutModal,
  Help: HelpModal,
  Summary: SummaryModal,
  ContractId: ContractIdModal,
  DefinitionId: DefinitionIdModal,
  ContentModal: ContentModal,
  FileModal: FileModal,
  CoachModal: CoachModal,
}

export { default as ModalPage } from './modal/templates/page/ModalPage'
export { default as ModalPopup } from './modal/templates/popup/ModalPopup'
export { default as FileModalPopup } from './modal/templates/file_modal_popup/FileModalPopup'



// WEBPACK FOOTER //
// ./src/components/modals/index.js